var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20px 20px",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18a8 8 0 110-16 8 8 0 010 16z",
    fill: "#4C6AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15 6.2a.5.5 0 01.5-.5h.7a.5.5 0 01.5.5v.7a.5.5 0 01-.5.5h-.7a.5.5 0 01-.5-.5v-.7zm0 2.85a.5.5 0 01.5-.5h.7a.5.5 0 01.5.5v4.7a.5.5 0 01-.5.5h-.7a.5.5 0 01-.5-.5v-4.7z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/alert_info.1339783d.svg";
export { SvgAlertInfo as ReactComponent };